module.exports = __webpack_public_path__ + "img/heart-bg-red.0d95259c.svg";